<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-input
                :validations="validations.protocoloCross"
                label="Prontuário estadual (CROSS)"
                v-model="model.documentos.outro.protocoloCross"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                protocoloCross: {max: 10},
            }
        },
    },
    props: {
        model: {type: Object, required: true},
    },
}
</script>